import { Roles } from "../../../util/PermissionProvider";
import PersonAddIcon from "@material-ui/icons/PersonAdd";

const menu = [
  {
    name: "Walk-in Registration",
    path: "/walk-in/registration",
    icon: <PersonAddIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.CINECLUB_WI_EDITOR],
    children: [
      {
        name: "Register Member",
        path: "/walk-in/registration",
      },
    ],
  },
];

export default menu;
